import settingService from '../../services/settings-service'

const state = {
    loading: false,
    errors: null,
    settings: {}
}

const actions = {
    getAll({ commit }) {
        commit('LOADING', true)
        settingService.getAll().then(
            response => {

                commit('LOAD', response.data)
                commit('FAILURE', null)
                commit('LOADING', false)
            },
            error => {
                commit('FAILURE', error)
                commit('LOADING', false)
            }
        )
    },
    add({ commit }, data) {

        commit('LOADING', true)
        settingService.add(data).then(
            response => {


                commit('ADD', response.data)
                commit('FAILURE', null)
                commit('LOADING', false)
            },
            error => {
                commit('FAILURE', error)
                commit('LOADING', false)
            }
        )
    },


}

const mutations = {
    ADD(state, payload) {
        state.settings = payload;
    },
    LOAD(state, payload) {
        state.settings = payload
    },

    FAILURE(state, payload) {
        state.errors = payload
    },

    LOADING(state, payload) {
        state.loading = payload
    },
}

const getters = {
    SETTINGS: state => {
        return state.settings
    },

    SETTING_ERROR: state => {
        return state.error
    },

    SETTING_LOADING: state => {
        return state.loading
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}